module.exports = __webpack_public_path__ + "img/path.9768f44d.png";